module.exports = __webpack_public_path__ + "img/share-table-left.14b0dddb.png";